import React, { useEffect, useState } from "react"
import moment from "moment"
import { IdleTimeOutModal } from "./IdleTimeOutModal"
const IdleTimeOutHandler = ({
  onLogout,
  onActive,
  onIdle,
  timeOutInterval,
}) => {
  moment.locale("pt-br")
  const [showModal, setShowModal] = useState(false)
  const [isLogout, setLogout] = useState(false)
  const timeOutTimer = 1000 * 60 * 15 // 15min
  // const timeOutTimer = 1000 * 5 // 5s
  let timer = undefined
  const events = ["click", "scroll", "load", "keydown"]
  const eventHandler = eventType => {
    if (!isLogout) {
      localStorage.setItem("lastInteractionTime", moment())
      if (timer) {
        onActive()
        startTimer()
      }
    }
  }
  useEffect(() => {
    addEvents()

    return () => {
      removeEvents()
      clearTimeout(timer)
    }
  }, [])

  const startTimer = () => {
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(
      () => {
        let lastInteractionTime = localStorage.getItem("lastInteractionTime")
        const diff = moment.duration(moment().diff(moment(lastInteractionTime)))
        let _timeOutInterval = timeOutInterval ? timeOutInterval : timeOutTimer
        if (isLogout) {
          clearTimeout(timer)
        } else {
          if (diff._milliseconds < _timeOutInterval) {
            startTimer()
            onActive()
          } else {
            onIdle()
            setShowModal(true)
          }
        }
      },
      timeOutInterval ? timeOutInterval : timeOutTimer
    )
  }
  const addEvents = () => {
    events.forEach(eventName => {
      window.addEventListener(eventName, eventHandler)
    })
    startTimer()
  }
  const removeEvents = () => {
    events.forEach(eventName => {
      window.removeEventListener(eventName, eventHandler)
    })
  }
  const handleContinueSession = () => {
    setShowModal(false)
    setLogout(false)
    onActive()
    startTimer()
  }
  const handleLogout = () => {
    removeEvents()
    clearTimeout(timer)
    setLogout(true)
    setShowModal(false)
    onLogout()
  }

  return (
    <div>
      <IdleTimeOutModal
        showModal={showModal}
        setShowModal={setShowModal}
        handleContinue={handleContinueSession}
        handleLogout={handleLogout}
      />
    </div>
  )
}

export default IdleTimeOutHandler
